import React from 'react';
import styles from './style/point-progress-bar.module.scss';
import PropTypes from 'prop-types'

const PointProgressBar = ({ level, totalLevels, className='' }) => {
    const getCircles = () => {

        return Array.from({ length: totalLevels }, (_, i) => (
            <div
                key={`PointProgressBar-${i}`}
                className={`${styles.circle} ${i < level ? styles.filled : ''}`}
            />
        ));
    };

    return <div className={`${className} ${styles['progress-bar']}`}>{getCircles()}</div>;
};

PointProgressBar.propTypes = {
    level: PropTypes.number,
    totalLevels: PropTypes.number,
    className: PropTypes.string
}

PointProgressBar.defaultProps = {
    totalLevels: 5,
}


export default PointProgressBar;
